package co.maytes.standupbot.dashboard.features.settings

import co.maytes.standupbot.dashboard.features.integrations.LoadState
import co.maytes.standupbot.dashboard.features.membersSettings.MembersSettingsContract
import co.maytes.standupbot.dashboard.features.onboarding.WatchedReposLoadState

enum class StatePhase { Loading, Error, Ready }

fun LoadState.phase(): StatePhase = when (this) {
    LoadState.Idle, LoadState.Loading -> StatePhase.Loading
    is LoadState.Error -> StatePhase.Error
    LoadState.Ready -> StatePhase.Ready
}

fun WatchedReposLoadState.phase(): StatePhase = when (this) {
    WatchedReposLoadState.Idle, WatchedReposLoadState.Loading -> StatePhase.Loading
    is WatchedReposLoadState.Error -> StatePhase.Error
    WatchedReposLoadState.Ready -> StatePhase.Ready
}

fun MembersSettingsContract.Status.phase(): StatePhase = when (this) {
    MembersSettingsContract.Status.Idle, MembersSettingsContract.Status.Loading -> StatePhase.Loading
    is MembersSettingsContract.Status.Error -> StatePhase.Error
    MembersSettingsContract.Status.Ready -> StatePhase.Ready
}
